(function () {
  'use strict';

  // Irish public holidays are skipped via weekend logic only (sat/sun).
  // +3 business days from today.

  const DAYS  = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(date, n) {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatShipDate(date) {
    return `${DAYS[date.getDay()]}, ${pad(date.getDate())} ${MONTHS[date.getMonth()]}`;
  }

  function getSecondsUntilMidnight() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(23, 59, 59, 999);
    return Math.floor((midnight - now) / 1000);
  }

  function formatCountdown(totalSeconds) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${pad(h)}h ${pad(m)}m ${pad(s)}s`;
  }

  function initWidget(el) {
    if (el.dataset.initialized) return;
    el.dataset.initialized = 'true';

    const dateEl      = el.querySelector('.estimated-shipping__date');
    const countdownEl = el.querySelector('.estimated-shipping__countdown');

    if (!dateEl || !countdownEl) return;

    // Ship date: +3 business days
    const shipDate = addBusinessDays(new Date(), 3);
    dateEl.textContent = formatShipDate(shipDate);

    // Countdown to 23:59:59, resets at midnight
    let seconds = getSecondsUntilMidnight();
    countdownEl.textContent = formatCountdown(seconds);

    const interval = setInterval(() => {
      seconds--;
      if (seconds < 0) {
        seconds = getSecondsUntilMidnight();
        // Recalculate ship date at midnight rollover
        const newShipDate = addBusinessDays(new Date(), 3);
        dateEl.textContent = formatShipDate(newShipDate);
      }
      countdownEl.textContent = formatCountdown(seconds);
    }, 1000);

    // Animate in
    requestAnimationFrame(() => {
      requestAnimationFrame(() => el.classList.add('is-ready'));
    });
  }

  function initAll() {
    document.querySelectorAll('.estimated-shipping:not([data-initialized])').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();